export default class User {
    constructor(api) {
        this.api = api;
    }

    setAvatar(avatar) {
        let promise = this.api.post('account', 'set-avatar', {avatar});
        promise.then(() => {
            this.loadData(true)
        });
        return promise;
    }

    removeAvatar() {
        let promise = this.api.post('account', 'remove-avatar');
        promise.then(() => {
            this.loadData(true)
        });
        return promise;

    }

    setResetMail(reset_mail) {
        let promise = this.api.post('account', 'set-reset-mail', {reset_mail});
        promise.then(() => {
            this.loadData(true)
        });
        return promise;
    }

    removeResetMail() {
        let promise = this.api.post('account', 'remove-reset-mail');
        promise.then(() => {
            this.loadData(true)
        });
        return promise;

    }

    confirmResetMail(uid, token) {
        return this.api.post('account', 'confirm-reset-mail', {uid, token});
    }
}